<template>
  <v-container fluid class="py-0" style="text-align: end">
    <v-row class="align-center">
      <v-spacer></v-spacer>
      <v-col v-if="rowsPerPageItems.length > 0" cols="auto" xs="3" px-0 pr-2>
        <span>{{ rowsPerPageText }}</span>
      </v-col>
      <v-col
        v-if="rowsPerPageItems.length > 0"
        cols="auto"
        class="rows-per-page-container justify-center"
      >
        <v-select
          v-model="pagination.rowsPerPage"
          class="pt-2 rows-select"
          variant="underlined"
          :items="rowsPerPageItems"
          @input="setRowsCount"
          dense
        />
      </v-col>
      <v-col cols="auto" style="text-align: center">
        <span>{{ rangeDisplay }}</span>
      </v-col>
      <v-col cols="auto" align-self-center class="text-xs-right">
        <!--        <v-btn variant="text" class="px-0 left-page-button" @click="decrement">-->
        <!--          <v-icon>fa-solid fa-angle-left</v-icon>-->
        <!--        </v-btn>-->
        <v-btn
          variant="text"
          icon="fa-solid fa-angle-left"
          size="small"
          class="px-0"
          @click="decrement"
        />
        <v-btn
          variant="text"
          icon="fa-solid fa-angle-right"
          size="small"
          class="px-0"
          @click="increment"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import useFormatters from "@/mixins/formatters.js";

export default {
  name: "DataTablePagination",
  // mixins: [formatters],
  props: {
    pagination: {
      type: Object,
      default: function () {
        return {
          page: 1,
          rowsPerPage: 10,
          descending: false,
          sortBy: "",
          totalItems: 0,
        };
      },
    },
    totalItems: {
      type: Number,
      default: 0,
    },
    rowsPerPageItems: {
      type: Array,
      default: function () {
        return [10, 20, 40];
      },
    },
    rowsType: {
      type: String,
      default: "rows",
    },
    // rowsPerPageText: {
    //   type: String,
    //   default: "Rows per page:"
    // }
  },
  computed: {
    pages() {
      return Math.ceil(this.totalItems / this.pagination.rowsPerPage);
    },
    rangeDisplay() {
      // calculate top and bottom range
      let top =
        this.totalItems -
        (this.totalItems - this.pagination.page * this.pagination.rowsPerPage);
      let bottom = top - this.pagination.rowsPerPage + 1;
      // adjust if this is the last page to show the accurate number of results
      if (top > this.totalItems) {
        top = this.totalItems;
        let remainder = this.totalItems % this.pagination.rowsPerPage;
        bottom = top - remainder + 1;
      }

      if (bottom === 1 && top === 0 && this.totalItems === 0) {
        return "-";
      }

      let ofTypeText = this.rowsType;
      if (this.rowsType === "dnc" || this.rowsType === "qa") {
        ofTypeText = this.rowsType.toUpperCase();
      }

      return `${this.formatNumberWithCommas(bottom)}
        - ${this.formatNumberWithCommas(top)} of
          ${this.formatNumberWithCommas(this.totalItems)} ${ofTypeText}`;
    },
    rowsPerPageText() {
      let perPageTypeText = this.titleCase(this.rowsType);
      if (this.rowsType === "dnc" || this.rowsType === "qa") {
        perPageTypeText = this.rowsType.toUpperCase();
      }

      return `${perPageTypeText} per page:`;
    },
  },
  data() {
    return {};
  },
  methods: {
    ...useFormatters(),
    increment() {
      if (this.pagination.page < this.pages) {
        this.pagination.page++;
      }
    },
    decrement() {
      if (this.pagination.page > 1) {
        this.pagination.page--;
      }
    },
    setRowsCount(value) {
      this.pagination.rowsPerPage = value;
      this.pagination.page = 1;
    },
  },
};
</script>

<style scoped>
.v-btn :deep(.v-icon) {
  font-size: 18px;
}

.rows-select {
  min-width: 60px !important;
  max-width: 60px !important;
  margin: 0 !important;
}

.rows-select :deep(.v-select__selection-text) {
  font-size: 14px;
}
/*.v-select :deep(.v-select__menu-icon) {*/
/*  font-size: unset;*/
/*}*/

/*.pagination-button-container {*/
/*  min-width: 85px !important;*/
/*  max-width: 85px !important;*/
/*}*/
/*.pagination-button-container >>> .v-btn {*/
/*  margin: 0 !important;*/
/*}*/

.left-page-button {
  margin: 0 0 0 0 !important;
}

.right-page-button {
  margin: 0 0 0 0 !important;
}
</style>
